import { Navigate, Outlet } from "react-router-dom";
import { auth } from "../firebase/index";

const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
  return !!auth.currentUser ? <Outlet /> : <Navigate to="/giris-yap" />;
};

export default PrivateRoute;
